import axios from 'axios'

/**
 * Tells the backend an offer was actually shown.
 *
 * Every other funnel milestone is a state change the server makes for itself,
 * so it is recorded where it happens. Seeing a paywall is not: it is a modal
 * the browser decides to render, and nothing reaches the server until the
 * visitor acts on it. Without this, `paywall_viewed` sat permanently at zero
 * while `checkout_opened` counted people who had plainly seen one.
 *
 * Deliberately not routed through the analytics consent gate. This is a
 * first-party product metric written to Yumnia's own database, the same as the
 * milestones recorded server-side either side of it, and gating it would make
 * the funnel's denominator depend on the banner while its numerator did not.
 * Nothing about the person is sent, only which surface was shown.
 *
 * Never throws: a measurement failure must not break the paywall it measures.
 *
 * @param {string} surface
 */
export async function reportPaywallViewed (surface) {
  try {
    await axios.post('/api/funnel/paywall-viewed', { surface: String(surface || 'unknown') })
  } catch {
    // Measurement is never worth breaking the offer over.
  }
}
